import { io, Socket } from 'socket.io-client';

import { getSocketAPI } from '../utils/apiEndpointHelpers';
import { Subscribers } from './subscribers';

export let socket: undefined | Socket;

export function connectSocket(token: string) {
  const SOCKET_URL = getSocketAPI();

  try {
    const opts = {
      transports: ['websocket'],
      reconnectionDelay: 5000,
      reconnection: true,
      reconnectionAttempts: Infinity,
      auth: {
        token: token,
      },
      cors: {
        origin: SOCKET_URL,
      },
    };

    socket = io(SOCKET_URL, opts);
    socket.on('connect', function () {
      if (socket) {
        Subscribers(socket);
      }
      console.log('socket connected');
    });
    socket.on('connect_error', function (err) {
      console.log('connect error', err);
    });
  } catch (err) {
    console.log('error', err);
  }

  return socket;
}
